import { useState, useEffect } from 'react';
import { fetchThemes, ThemeInfo } from '../services/feedService';

// La liste des thèmes est la même pour toute l'application et ne change pas
// pendant une visite. On mémorise la promesse plutôt que le résultat, pour que
// deux composants montés en même temps partagent un seul appel réseau.
let pending: Promise<ThemeInfo[]> | null = null;

const loadThemes = (): Promise<ThemeInfo[]> => {
  if (!pending) {
    pending = fetchThemes().catch(err => {
      console.error('Erreur lors du chargement des thèmes:', err);
      // On oublie l'échec pour qu'un prochain montage puisse réessayer.
      pending = null;
      return [];
    });
  }
  return pending;
};

export const useThemes = () => {
  const [themes, setThemes] = useState<ThemeInfo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    loadThemes().then(loaded => {
      if (cancelled) return;
      setThemes(loaded);
      setLoading(false);
    });

    return () => { cancelled = true; };
  }, []);

  return { themes, loading };
};
